import styled from "styled-components";
import CloseImg from "@/assets/svg/close.svg";
import { ReactSVG } from "react-svg";
import { chainId } from "@/utils/abi";
import { useSwitchNetwork } from 'wagmi'

export default function Walltes({ handleClose }) {
    const { switchNetworkAsync } = useSwitchNetwork()  

    const handleSwitch = async()=>{
      const res = await switchNetworkAsync(chainId)
      if(res?.id === chainId){
        handleClose()
      }
    }
    
  return (
    <Modal>
      <div className="close">
        <ReactSVG src={CloseImg} />
      </div>
      <div className="content">
        <div className="title">Change NetWork</div>
        <div onClick={handleSwitch} className="button-item">Switch</div>
      </div>
    </Modal>
  );
}

const Modal = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-top: 32px;
  position: relative;
  background: #000;
  .close {
    position: absolute;
    right: 35px;
    top: 42px;
    cursor: pointer;
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .button-item{
      width: 86%;
      box-sizing: border-box;
      height: 44px;
      line-height: 44px;
      background: #32DE86;
      border-radius: 8px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      margin: 24px 0;
      cursor: pointer;
      font-size: 16px;
      margin-bottom: 32px;      
      &:hover{
        background:#239B5E; 
      }
    }
  }
  .title {
    font-weight: 600;
    font-size: 24px;  
    line-height: 34px;    
    color: #32DE86;
    padding-bottom: 27px;
  }
  
`;
